import {
  Dropdown,
  DropdownList,
  DropdownProps,
  Select,
} from '@toggle/design-system';
import styled from 'styled-components';

export const ConditionDataDropdown = styled(Dropdown)`
  width: 161px;
  z-index: var(--z-index-modal);

  ${DropdownList.Styled.DropdownListRoot} {
    width: 300px;
  }
` as <T>(props: DropdownProps<T>) => JSX.Element;

export const StyledSelect = styled(Select)`
  width: 161px;
  input {
    width: 100%;
  }
`;
